<template>
  <a-card>
    <span slot="title"
      >Project {{ mode === "Create" ? "Create" : "Change" }} Form</span
    >
    <a-steps :current="current" status="process">
      <a-step title="Project" hidden/>
      <a-step title="RAB" hidden/>
      <a-step title="Contract Information" hidden/>
    </a-steps>
    <div
      :class="
        steps[current].content === 'Informasi'
          ? 'padding-remove steps-content flex-1'
          : 'steps-content flex-1'
      "
    >
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <!-- <a-button v-if="current < steps.length - 1" type="primary" @click="next"
          >Next</a-button
        >
        <a-button
          :loading="btnLoading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >Save</a-button
        > -->
        <a-button
          v-if="complete_mode"
          :loading="btnLoading"
          type="primary"
          @click="next"
          >Update</a-button>

        <a-button
          v-else
          :loading="btnLoading"
          type="primary"
          @click="next"
          >Save</a-button
        >
        <!-- <a-button v-if="current > 0" @click="prev">Previous</a-button> -->
      </div>
    </template>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Project from "./steps/Project.vue";
import Rab from "./steps/Rab.vue";
import Informasi from "./steps/Informasi.vue";
import NewFromAllIn from "./steps/NewformAllInOne.vue";
import moment from "moment";

export default {
  name: "projectRabCreate",
  props: ["id","complete"],
  components: {
    Informasi,
    Rab,
    Project,
    NewFromAllIn,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "NewFromAllIn",
          content: "NewFromAllIn",
        },
        {
          title: "Project",
          content: "Project",
        },
        {
          title: "RAB",
          content: "Rab",
        },
        {
          title: "Informasi",
          content: "Informasi",
        },
      ],
      btnLoading: false,
      mode: "Create",
      complete_mode: false,
      collectData: {},
    };
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchData();
      if(this.complete){
        this.complete_mode = true
      }
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getDateTimeFormat",
    ]),
    stepProps() {
      let step = {};
      if (this.mode == "Edit") {
        if (this.steps[this.current].content == "Project") {
          step = {
            data: this.collectData.project,
            info: this.collectData.info,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content == "Rab") {
          step = {
            data: this.collectData.rab,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content == "Informasi") {
          step = {
            data: this.collectData.informasi,
            info: this.collectData.info,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content == "NewFromAllIn") {
          step = {
            listeditNRD: this.collectData.rnd ? this.collectData.rnd : [],
            listEditSalesNotif: this.collectData.sales_notification ? this.collectData.sales_notification : [],
            data: this.collectData.project,
            mode: this.mode,
            disableButton: this.complete_mode
          };
        }
      } else if (this.mode == "Create") {
        if (this.steps[this.current].content == "Project") {
          step = {
            data: this.collectData.project,
            info: this.collectData.info,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content == "Rab") {
          step = {
            data: this.collectData.rab,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content == "Informasi"){
          step = {
            data: this.collectData.informasi,
            info: this.collectData.info,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content == "NewFromAllIn") {
          step = {
            data: this.collectData.project,
            mode: this.mode,
          };
        }
      }

      return step;
    },
    stepRef() {
      let ref = "";
      if (this.steps[this.current].content === "NewFromAllIn") {
        ref = "refNewFromAllIn";
      } else if (this.steps[this.current].content === "Project") {
        ref = "refProject";
      } else if (this.steps[this.current].content === "Rab") {
        ref = "refRab";
      } else if (this.steps[this.current].content === "Informasi") {
        ref = "refInformasi";
      }

      return ref;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "project/edit",
        params: {
          tlc: this.getAuth.username,
          project_id: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.collectData = {
            project: response.data.data[0],
            sales_notification: response.data.sales_notification,
            rnd: response.data.rnd,
          };
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    next() {
      // if (this.steps[this.current].content === "Project") {
      //   this.$refs.refProject.handleRef();
      // } else if (this.steps[this.current].content === "Rab") {
      //   this.$refs.refRab.handleRef();
      // }
      if (this.steps[this.current].content === "NewFromAllIn") {
        this.$refs.refNewFromAllIn.handleRef();
      }
    },
    prev() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRefBack();
      }
      this.current--;
    },
    validate() {
      if (this.mode === "Edit" && !this.complete_mode) {
        this.confirmMessage("confirm-edit");
      } else if(this.mode === "Edit" && this.complete_mode){
        this.confirmMessage("confirm-update");
      } else if (this.mode === "Create") {
        this.confirmMessage("confirm-save");
      }
    },
    valueFromChildBack(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = value;
      }
    },
    valueFromChild(value) {
      // if (this.steps[this.current].content === "Project") {
      //   this.collectData.project = value.project;
      //   this.collectData.info = value.jenis;
      //   this.current++;
      // } else if (this.steps[this.current].content === "Rab") {
      //   this.collectData.rab = JSON.parse(JSON.stringify(value));
      //   this.current++;
      // } else if (this.steps[this.current].content === "Informasi") {
      //   this.collectData.informasi = value;
      // }

      if (this.steps[this.current].content === "NewFromAllIn") {
        this.collectData.project = value.project;
        this.validate()
      }
    },
    submit() {
      // this.$refs.refInformasi.handleRef();

      // diperbolehkan detail list kosong, karena kebiasaan sebelumnya tidak pernah mengisi detail list
      // if (this.collectData.informasi.detail_list.length == 0) {
      //   this.displayMessage("error-empty-product");
      // } else {
        let data = new FormData();
        let url = "";

        this.btnLoading = true;

        data.append("tlc", this.getAuth.username);
        data.append("site", this.collectData.project.site);
        data.append(
          "active_sts",
          parseInt(this.collectData.project.active_sts)
        );
        data.append("budget_type", this.collectData.project.budge_type);
        if(this.collectData.project.inCaseType=="sales_notification"){
          data.append(
            "sales_notification",
            this.collectData.project.sales_notification
              ? this.collectData.project.sales_notification
              : ""
          );
        }else if(this.collectData.project.inCaseType=="rnd"){
          data.append(
            "sales_notification",
            this.collectData.project.rnd_notification
              ? this.collectData.project.rnd_notification
              : ""
          );
        }else if(this.collectData.project.inCaseType=="pipeline"){
          // data.append(
          //   "pipeline_id",
          //   this.collectData.project.pipeline_id
          //     ? this.collectData.project.pipeline_id
          //     : ""
          // );
          if(this.budge_type!='07')
            data.append(
              "id_prospek",
              this.collectData.project.id_prospek
                ? this.collectData.project.id_prospek
                : ""
            );
        }
        data.append("kode_proyek", this.collectData.project.kode_proyek);
        data.append("nama_proyek", this.collectData.project.nama_proyek);
        // data.append("durasi_start", this.collectData.project.durasi[0]);
        // data.append("durasi_end", this.collectData.project.durasi[1]);
        data.append("klien_id", this.collectData.project.klien);
        data.append("klien", this.collectData.project.klien_nm);
        data.append("perusahaan", this.collectData.project.perusahaan);
        data.append(
          "pimpinan_proyek",
          this.collectData.project.pimpinan_proyek
        );
        data.append("akun_manajer", this.collectData.project.akun_manajer);
        data.append("direktorat", this.collectData.project.direktorat);
        data.append("general_affair", this.collectData.project.general_affair);
        data.append("finance", this.collectData.project.finance);

        if(this.collectData.project.budge_type == '02'){
          data.append("project_department", this.collectData.project.department);
          data.append("pic_department", this.collectData.project.pic_dept);
        }
        // data.append("peruntukan", this.collectData.project.peruntukan);
        // data.append(
        //   "anggaran_marketing",
        //   this.collectData.rab.anggaran_marketing
        //     ? this.collectData.rab.anggaran_marketing
        //     : 0
        // );
        // data.append(
        //   "anggaran_produksi",
        //   this.collectData.rab.anggaran_produksi
        //     ? this.collectData.rab.anggaran_produksi
        //     : 0
        // );
        // data.append(
        //   "anggaran_implementasi",
        //   this.collectData.rab.anggaran_implementasi
        //     ? this.collectData.rab.anggaran_implementasi
        //     : 0
        // );
        // data.append(
        //   "anggaran_ga",
        //   this.collectData.rab.anggaran_ga
        //     ? this.collectData.rab.anggaran_ga
        //     : 0
        // );
        // data.append(
        //   "nomor_kontrak",
        //   this.collectData.informasi.kontrak.nomor_kontrak
        //     ? this.collectData.informasi.kontrak.nomor_kontrak
        //     : ""
        // );
        // data.append(
        //   "judul",
        //   this.collectData.informasi.kontrak.judul_kontrak
        //     ? this.collectData.informasi.kontrak.judul_kontrak
        //     : ""
        // );
        // data.append(
        //   "tanggal_kontrak",
        //   this.collectData.informasi.kontrak.tanggal_kontrak
        // );
        // data.append(
        //   "jenis",
        //   this.collectData.informasi.kontrak.jenis
        //     ? this.collectData.informasi.kontrak.jenis
        //     : ""
        // );

        // this.collectData.informasi.detail_list.forEach((item) => {
        //   data.append("nama_produk[]", item.nama_produk);
        //   data.append("jumlah[]", item.jumlah ? item.jumlah : 0);
        //   data.append("satuan[]", item.satuan);
        // });

        // if (this.collectData.informasi.file_upload.length > 0) {
        //   this.collectData.informasi.file_upload.forEach((dokumen) => {
        //     data.append("file_dokumen", dokumen);
        //   });
        // }
        if (this.mode === "Create") {
          url = this.$serviceUrl + "project";
        } else if (this.mode === "Edit") {
          url = this.$serviceUrl + "project/edit";
          data.append("project_id", this.collectData.project.project_id);
        }

        axios({
          method: "post",
          url: url,
          processData: false,
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            if (this.mode === "Create") {
              this.displayMessage("success-save");
            } else {
              this.displayMessage("success-edit");
            }
            Event.$emit("rabkeepalive", false);
            this.btnLoading = false;

            this.$router.go(-1);
          })
          .catch((err) => {
            let response = Object.assign({}, err.response.data);
            if (
              response.message.includes("kode proyek sudah pernah digunakan")
            ) {
              this.displayMessage("error-exist_project_code");
            }
            this.btnLoading = false;
          });
      // }
    },

    onUpdateSubmit(){
      let data = new FormData();
      this.btnLoading = true;

      data.append("pimpinan_proyek",this.collectData.project.pimpinan_proyek);
      data.append("akun_manajer", this.collectData.project.akun_manajer);
      data.append("direktorat", this.collectData.project.direktorat);
      data.append("general_affair", this.collectData.project.general_affair);
      data.append("finance", this.collectData.project.finance);
      data.append("project_id", this.collectData.project.project_id);
      data.append("budget_type", this.collectData.project.budge_type);
      
      if(this.collectData.project.budge_type == '02'){
        data.append("project_department", this.collectData.project.department);
        data.append("pic_department", this.collectData.project.pic_dept);
      }

      axios({
        method: "POST",
        url: this.$serviceUrl + "project/update",
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      }).then((response) => {
        this.displayMessage("success-edit");
        Event.$emit("rabkeepalive", false);
        this.btnLoading = false;
        this.$router.go(-1);
      }).catch((err) => {
        let response = Object.assign({}, err.response.data);
        if (
          response.message.includes("kode proyek sudah pernah digunakan")
        ) {
          this.displayMessage("error-exist_project_code");
        }
        this.btnLoading = false;
      });
    }

  },

  mounted() {
    Event.$on("projectrab", this.valueFromChild);
    Event.$on("projectrabBack", this.valueFromChildBack);
    Event.$on("refresh", this.fetchData);
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("confirmUpdateReturn", this.onUpdateSubmit);
  },
  beforeDestroy() {
    Event.$off("projectrab", this.valueFromChild);
    Event.$off("projectrabBack", this.valueFromChildBack);
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("confirmUpdateReturn", this.onUpdateSubmit);
  },
};
</script>

<style>
</style>